//EQUIPMENT_TYPE
export const EQUIPMENT_TRACTOR = 1;
export const EQUIPMENT_IMPLEMENT = 2;
export const EQUIPMENT_TRUCK = 3;
export const EQUIPMENT_SELF_PROPELLED = 6;
export const EQUIPMENT_PERSON = 7;
export const EQUIPMENT_HANDLING = 8;
export const EQUIPMENT_SCALE = 9;
export const EQUIPMENT_REMOTECONTROL = 10;

//Harvesting CATEGORY
export const HARVESTING_CATEGORYIDS = [9, 27, 34, 31];

//Cart CATEGORY
export const CART_CATEGORYIDS = [28];

//Person CATEGORY
export const PERSON_CATEGORY = 44;

//BALER CATEGORY
export const BALER_CATEGORYIDS = [29];

//BALER CATEGORY
export const PLANTER_CATEGORYIDS = [4];

//EQUIPMENT GROUP OPTION TYPES
export const EG_OPTION_TYPES = ["vehicle", "implement", "device", "operator"];

//NOTIFICATION NAMES
export const TOPIC_LATEST_EG_SENSOR = 'latest_eg_sensor';
export const TOPIC_SENSOR = 'sensor';

export const TOPIC_QLOST = 'q-lost';
export const TOPIC_QCONNECTION = 'q-connection';

export const TOPIC_LATEST_KPI_PLAN = 'latest_farm_kpi';
export const TOPIC_KPI_PLAN = 'farm_kpi';
export const TOPIC_LOAD_PLAN = 'farm_load_kpi';

export const TOPIC_LATEST_KPI_CREW = 'latest_crew_kpi';
export const TOPIC_KPI_CREW = 'crew_kpi';
export const TOPIC_LOAD_CREW = 'crew_load_kpi';

export const TOPIC_LATEST_EG_GPS = 'latest_eg_gps';
export const TOPIC_LATEST_KPI_EG = 'latest_eg_kpi';
export const TOPIC_KPI_EG = 'equipment_group_kpi';
export const TOPIC_LOAD_EG = 'crew_load_kpi';

export const NOTIFICATION_SUBSCRIBE = 'subscribe';
export const NOTIFICATION_UNSUBSCRIBE = 'unsubscribe';

export const COMMAND_INSERT = 'command/insert';

//SUSBSCRIPTION GROUP
export const GROUP_ANALYZE_KPI = 'ANALYZE_KPI';
export const GROUP_DASHBOARD_ANALYZE_KPI = 'DASHBOARD_ANALYZE_KPI';
export const GROUP_MAP_KPI = 'MAP_KPI';
export const GROUP_FARM_MONITOR_ANALYZE_KPI = "FARM_MONITOR_ANALYZE_KPI";
export const GROUP_FARM_MONITOR_DEVICE_KPI = "FARM_MONITOR_DEVICE_KPI";

// MAP
export const DEFAULT_MAP_LOCATION = { lat: 42.536136, lng: -113.792653 };
export const UNKNOWN_OPERATOR = "Unknown Operator";

//SENSOR
export const SENSOR_GPS = "gps";
export const SENSOR_CGPS = "cgps0";
export const SENSOR_PTO = "pto";
export const SENSOR_BALE = "bale";

//OTHERS
export const NOT_APPLICABLE = "N/A";
export const UNAVAILABLE = "Unavailable";

//DATE AND TIMEZONE
export const DISPLAY_DATE_FORMAT = "MM/DD/YYYY";
export const DISPLAY_DATE_FORMAT2 = "DD MMM YYYY";
export const DISPLAY_DATE_FORMAT3 = "DD MMM";
export const DISPLAY_DATETIME_FORMAT = "DD-MMM-YYYY hh:mm a";
export const DISPLAY_DATETIME_FORMAT2 = "DD MMM YYYY hh:mm a";
export const DISPLAY_DATETIME_FORMAT3 = "DD-MMM-YYYY hh:mm A";
export const DISPLAY_DATETIMESECONDS_FORMAT2 = "DD MMM YYYY hh:mm:ss a";
export const DISPLAY_DATE_WITH_MIN_SEC_MSEC = "DD MMM YYYY hh:mm:ss:SSS a";
export const DISPLAY_DATETIME_WITHOUT_YEAR_FORMAT = "DD-MMM hh:mm a";
export const DISPLAY_DATETIME_WITHOUT_YEAR_FORMAT2 = "DD MMM hh:mm a";
export const DISPLAY_DATETIMESECONDS_WITHOUT_YEAR_FORMAT2 = "DD MMM hh:mm:ss a";
export const DISPLAY_TIME_FORMAT = "hh:mm A";
export const DISPLAY_TIME_FORMAT2 = "hh:mm a";
export const DISPLAY_TIME_FORMAT3 = "hh:mm:ss A";
export const API_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const API_DATE_FORMAT = "YYYY-MM-DD";
export const API_TIME_FORMAT = "HH:mm:ss";

//VIEW
export const VIEW_PLAN = "plan";
export const VIEW_CREW = "crew";
export const VIEW_EG = "eg";
export const VIEW_CUSTOMER = "customer";

//TYPE
export const TYPE_TRUCK = "truck";

// RATE SCHEDULE TYPES
export const RATE_TYPE_LISTS = {
    RATE_TYPE: 1,
    SURCHARGE_TYPE: 2
}

//RANGE
export const RANGE_TYPE_TODAY = "today";
export const RANGE_TYPE_YESTERDAY = "yesterday";
export const RANGE_TYPE_TODATE = "todate";
export const RANGE_TYPE_PLANNED = "planned";
export const RANGE_TYPE_CUSTOM = "custom";
export const RANGE_TYPE_ABSOLUTE = "absolute";
export const rangeList = [
    {
        id: "today",
        name: "Today"
    },
    {
        id: "yesterday",
        name: "Yesterday"
    },
    {
        id: "last3days",
        name: "Last 3 days",
        unit: "days",
        amount: 3
    },
    {
        id: "last5days",
        name: "Last 5 days",
        unit: "days",
        amount: 5
    },
    {
        id: "thisweek",
        name: "This week",
        unit: "isoWeek",
        amount: 1,
        method: "startOf"
    },
    {
        id: "thismonth",
        name: "This month",
        unit: "month",
        amount: 0,
        method: "startOf"
    },
    {
        id: "last15days",
        name: "Last 15 days",
        unit: "days",
        amount: 15
    },
    {
        id: "last30days",
        name: "Last 30 days",
        unit: "days",
        amount: 30
    },
    {
        id: "last60days",
        name: "Last 60 days",
        unit: "days",
        amount: 60
    },
    {
        id: "last90days",
        name: "Last 90 days",
        unit: "days",
        amount: 90
    },
    {
        id: "last6month",
        name: "Last 6 month",
        unit: "months",
        amount: 6
    },
    {
        id: "last9month",
        name: "Last 9 month",
        unit: "months",
        amount: 9
    },
    {
        id: "planned",
        name: "Planned",
    },
    {
        id: "todate",
        name: "Todate",
    },
    {
        id: "thisYear",
        name: "This year",
        unit: "years",
        amount: 1
    }
];

//GRAPH
export const GRAPH_INTERVAL_MINUTES = 10;
export const GRAPH_INPUT_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss.000';

//CHAT
export const CHAT_DISPLAY_DATE_FORMAT_WITH_YEAR = "DD MMM YYYY hh:mm a";
export const CHAT_DISPLAY_DATE_FORMAT_WITHOUT_YEAR = "DD MMM hh:mm a";
export const CHAT_DISPLAY_TIME_FORMAT = "hh:mm a";
export const CHAT_MIME_TYPES = ["image/jpg", "image/png", "image/jpeg",
    "audio/mp3", "audio/mpeg", "video/mp4", "application/pdf",
    "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/msword", "text/plain"];
export const CHAT_MAX_FILE_SIZE_IN_MB = { default: 3, text: 5, application: 5, image: 8, video: 30, audio: 20 };
export const FILE_STORAGE_GOOGLE = "google";

//LOAD TYPE
export const LOAD_TYPE = {
    AUTOMATIC: 1,
    MANUAL: 2
}

// LOAD MODE
export const LOAD_MODE = {
    FIELD_CENTRIC: 1,
    OFFLOAD_CENTRIC: 2
}

//GEO FIELD TYPE
export const GEO_FIELD_TYPE = [
    { id: 2, name: "Field" },
    { id: 4, name: "Offload Site" },
    { id: 14, name: "Transload Site" },
    { id: 15, name: "Path" },
    { id: 9, name: "Region of Interest" },
    { id: 10, name: "Irrelevant Region" },
    { id: 11, name: "Point of Interest" }
];

// GEO REGION TYPE
export const REGION_TYPE = {
    FIELD: 2,
    OFFLOADSITE: 4,
    REGIONOFINTEREST: 9,
    IRRELEVANTREGION: 10,
    POINTOFINTEREST: 11,
    TRANSLOADSITE: 14
};

export const NON_FIELD_SHAPE_LIST_TYPE = [4, 9, 10, 11, 14];
//GEO MEME TYPES
export const GEO_MIME_TYPES = ["application/zip", ".zip", "application/vnd.google-earth.kml+xml", ".kml",
    ".shp", "application/octet-stream"];

//PLAN TYPE
export const HARVESTING_PLAN_TYPE_ID = 4;
export const LOGISTIC_PLAN_TYPE_ID = 5;
export const PLANTING_PLAN_TYPE_ID = 2;
export const PLAN_TYPE_LIST = [
    { plan_type_id: 10, plan_type: "All", workTypes: [1, 2, 3, 4, 5, 6, 7, 8, 9] },
    { plan_type_id: 1, plan_type: "Tillage", workTypes: [8] },
    { plan_type_id: 2, plan_type: "Planting", workTypes: [6] },
    { plan_type_id: 3, plan_type: "Cultivation", workTypes: [7] },
    { plan_type_id: 4, plan_type: "Harvesting", workTypes: [1, 2, 3, 4, 5, 9] },
    { plan_type_id: 5, plan_type: "Logistics", workTypes: [0] }
];
export const PLAN_TYPE_COLOURS = {
    1: "#8c6e63",
    2: "#029be6",
    3: "#ef6c25",
    4: "#5bac5f",
    5: "#004990"
};

//WORK TYPE
export const HARVEST_WORK_TYPE_IDS = [1, 2, 3, 4, 5, 9];
export const HARVESTING_WORK_TYPE_ID = 2;
export const PLANTING_WORK_TYPE_ID = 6;
export const WORK_TYPE_LIST = [
    { work_type_id: 8, work_type: "Tillage" },
    { work_type_id: 6, work_type: "Planting" },
    { work_type_id: 7, work_type: "Cultivation" },
    {
        work_type_id: 10,
        work_type: "Harvest",
        list: [
            { work_type_id: 1, work_type: "Transporting" },
            { work_type_id: 2, work_type: "Harvesting" },
            { work_type_id: 3, work_type: "Windrowing" },
            { work_type_id: 4, work_type: "Topping" },
            { work_type_id: 5, work_type: "Swathing" },
            { work_type_id: 9, work_type: "Baling" }]
    }
];

export const WORK_TYPE = {
    1: {
        work_type_id: 8,
        work_type: "Tillage"
    },
    2: {
        work_type_id: 6,
        work_type: "Planting"
    },
    3: {
        work_type_id: 7,
        work_type: "Cultivation"
    },
    4: {
        work_type_id: 2,
        work_type: "Harvest"
    }
}

export const WORK_TYPE_COLOURS = {
    1: "#5bac5f",
    2: "#5bac5f",
    3: "#5bac5f",
    4: "#5bac5f",
    5: "#5bac5f",
    9: "#5bac5f",
    8: "#8c6e63",
    6: "#029be6",
    7: "#ef6c25",
    10: "#5bac5f"
};

export const WORK_TYPE_COLOURS_SECONDARY = {
    1: "#a6daa9",
    2: "#a6daa9",
    3: "#a6daa9",
    4: "#a6daa9",
    5: "#a6daa9",
    9: "#a6daa9",
    8: "#cea392",
    6: "#a4cbdf",
    7: "#faac82",
    10: "#a6daa9"
};

//USER
export const QAPP_ROLE_ID = 6;
export const PERMISSION_BY_ID = {
    1: "View",
    2: "Create",
    3: "Edit",
    4: "Delete"
};
export const RECOMMENDED_ADMIN_CONTROLLERS = [1, 16, 22, 23, 24, 26];

// ORGANIZATION CONFIGURATIONS


export const VARIANT_COLOR_KEYS = ["lighter", "light", "main", "dark", "darker", "contrastText"];
export const GREY_COLOR_KEYS = ["100", "200", "300", "400", "500", "600", "700", "800", "900", "500_8", "500_12", "500_16", "500_24", "500_32", "500_48", "500_56", "500_80"];
export const ACTION_COLOR_KEYS = ["active", "hover", "selected", "disabled", "disabledBackground", "focus", "hoverOpacity", "disabledOpacity"];
export const COMMON_COLOR_KEYS = ["black", "white"];
export const TEXT_COLOR_KEYS = ["primary", "secondary", "disabled"];
export const BACKGROUND_COLOR_KEYS = ["paper", "default", "neutral"];

export const LOGO_MIME_TYPES = ["image/jpg", "image/png", "image/jpeg"];
export const LOGO_MAX_FILE_SIZE_IN_MB = 1;

export const ORGANIZATION_FONT_SIZES = [
    { value: '1rem', label: '1rem' },
    { value: '1.25rem', label: '1.25rem' },
    { value: '1.5rem', label: '1.5rem' },
    { value: '1.75rem', label: '1.75rem' },
    { value: '2rem', label: '2rem' },
    { value: '2.25rem', label: '2.25rem' },
    { value: '2.5rem', label: '2.5rem' },
];

export const ORGANIZATION_FONT_WEIGHT = [
    { value: '100', label: '100' },
    { value: '200', label: '200' },
    { value: '300', label: '300' },
    { value: '400', label: '400' },
    { value: '500', label: '500' },
    { value: '600', label: '600' },
    { value: '700', label: '700' },
    { value: '800', label: '800' },
    { value: '900', label: '900' },
    { value: 'bold', label: 'bold' },
    { value: 'bolder', label: 'bolder' },
    { value: 'lighter', label: 'lighter' },
    { value: 'nornal', label: 'nornal' },
];

export const ORGANIZATION_FONT_FAMILY = [
    { value: `inherit`, label: 'Default' },
    { value: `'Anton', sans-serif`, label: 'Anton' },
    { value: `'Abril Fatface', cursive`, label: 'Abril Fatface' },
    { value: `'Josefin Sans', sans-serif`, label: 'Josefin Sans' },
    { value: `'Lobster Two', cursive`, label: 'Lobster Two' },
    { value: `'Open Sans', sans-serif`, label: 'Open Sans' },
    { value: `'Righteous', cursive`, label: 'Righteous' },
    { value: `'Roboto Slab', serif`, label: 'Roboto Slab' },
];

// AUTO LOGOUT
export const AUTOLOGOUT_EXPIRY_MINUTES = 1440;
export const AUTOLOGOUT_PROMPT_WAITING_SECONDS = 15;
export const LOGIN_STATUS = {
    loggedIn: 'loggedIn',
    loggedOut: 'loggedOut',
    loginIdle: 'loginIdle',
    loginTimeout: 'logintimeout'
};

// FIELD LIST STATUS
export const COMPLETED_WORK_STATUS = 4;
export const ACTIVE_WORK_STATUS = 1;

//NOTIFICATIONS
export const SEMI_MAX_SPEED = 100; //miles
export const TRUCK_MAX_SPEED = 100; //miles
export const IDLE_MAX_TIME = 120; //minutes
export const MAX_PTO_RPM = 1000;
export const MAX_ENGINE_RPM = 2500;

//WEIGHT CONVERSION
export const ONE_CUBIC_METER_TO_KILOGRAM = 1000;
export const ONE_KILOGRAM_TO_HECTOGRAM = 10;

//SETTINGS
export const sampleOperatorChecklist = {
    "header": "your header here",
    "options": [
        {
            "id": 1,
            "type": "checkbox",
            "label": "your label here",
            "display_order": 1
        }
    ],
    "actions": {
        "positive": "Agree",
        "negative": "Cancel"
    }
}

//Load QUEUE SETTINGS
export const sampleLoadQueueSettings = {
    load_queue_params: [
        {
            label: "Colour",
            type: "options",
            key: "colour",
            values: ['Dark', 'Normal', 'Light'],
            visible: true,
            display_order: 1,
            plan_type_ids: [
                4
            ]
        },
        {
            key: "Multiselect",
            type: "multiselect",
            label: "Multi Select",
            values: [
                "One",
                "Two",
            ],
            default_values: ["One"],
            isMulti: true,
            visible: true,
            required: false,
            display_order: 2,
            plan_type_ids: [
                4
            ]
        }
    ]
}
// Inserted LoadQueue Parameters
export const loadQueueParameterSettings = {
    load_queue_params: [
        {
            "key": "truck",
            "type": "options",
            "label": "Truck",
            "values": [
                "1",
                "23",
                "345",
                "423",
                "9765"
            ],
            "visible": true,
            "display_order": 1,
            "plan_type_ids": [
                4
            ]
        },
        {
            "key": "load_ticket",
            "type": "text",
            "label": "Load Ticket #",
            "values": [],
            "visible": true,
            "display_order": 2,
            "plan_type_ids": [
                4
            ]
        },
        {
            "key": "temperature",
            "type": "number",
            "label": "Temperature",
            "values": [],
            "visible": true,
            "display_order": 3,
            "plan_type_ids": [
                4
            ]
        },
        {
            "key": "load_debris",
            "type": "multiselect",
            "label": "Load Debris",
            "values": [
                "Rocks",
                "Grass",
                "Dirt",
                "Corn Crowns",
                "Rot",
                "Vines"
            ],
            "isMulti": true,
            "visible": true,
            "required": false,
            "display_order": 4,
            "plan_type_ids": [
                4
            ]
        }
    ]
}


//Load Sampling SETTINGS
// export const LoadSamplingSettings = {
//     allowMultiple: false,
//     plan_type_ids: [1, 2, 3, 4, 5],
//     seed_load_sample_params: [
//         {
//             label: "Weight",
//             type: "number",
//             key: "sample_weight",
//             visible: true,
//             required: false,
//             display_order: 1
//         },
//         {
//             label: "Quality",
//             type: "options",
//             key: "sample_quality",
//             visible: true,
//             required: false,
//             values: ['Good', 'Normal', 'Poor'],
//             display_order: 2
//         }
//     ]
// }



export const LoadSamplingSettings = {
    allowMultiple: false,
    plan_type_ids: [1, 2, 3, 4, 5],
    add_title: 'Add Sample',
    edit_title: 'Edit Sample',
    view_title: 'Milestone Seed Cutter Sample',
    seed_load_sample_params: [
        {
            label: "Cutter Type",
            type: "options",
            key: "cutter_type",
            visible: true,
            required: false,
            values: ['1" Cut Top or Bottom Table', '2" Barrel Cut Bottom Table', '1 3/4" Barrel Cut Top Table', 'Horizontal Vertical Cut', 'One Drop'],
            display_order: 1,
            plan_type_ids: [1, 2, 3, 4, 5]
        },

        {
            label: "Weight Type",
            type: "options",
            key: "weight_type",
            visible: true,
            required: false,
            values: ['1.4 oz & under', '1.5 oz - 2.1 oz', '2.2 oz - 2.9 oz', '3.0 oz & over'],
            display_order: 2,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Total Count",
            type: "number",
            key: "total_count",
            visible: true,
            required: false,
            display_order: 3,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Weight",
            type: "number",
            key: "sample_weight",
            visible: true,
            required: false,
            display_order: 4,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "System Name",
            type: "number",
            key: "system_name",
            visible: true,
            required: false,
            display_order: 5,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Grower",
            type: "text",
            key: "seed_grower",
            visible: true,
            required: false,
            display_order: 6,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Variety",
            type: "text",
            key: "seed_variety",
            visible: true,
            required: false,
            display_order: 7,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Pulp Temp",
            type: "text",
            key: "seed_pulptemp",
            visible: true,
            required: false,
            display_order: 8,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Sampler Name",
            type: "text",
            key: "sampler_name",
            visible: true,
            required: false,
            display_order: 9,
            plan_type_ids: [1, 2, 3, 4, 5]
        },

    ]
}

export const LoadSamplingProfileSettings = {
    plan_type_ids: [1, 2, 3, 4, 5],
    title: 'Seed Piece Profile Table',
    seed_load_sample_params: [
        {
            label: "Cutter Type",
            type: "options",
            key: "cutter_type",
            visible: true,
            required: false,
            values: [{ key: 'cutter_type_1', label: '1 Cut Top or Bottom Table' }, { key: 'cutter_type_2', label: '2" Barrel Cut Bottom Table' }, { key: 'cutter_type_3', label: '1 3/4" Barrel Cut Top Table' }, { key: 'cutter_type_4', label: 'Horizontal Vertical Cut' }, { key: 'cutter_type_5', label: 'One Drop' }],
            display_order: 1,
            plan_type_ids: [1, 2, 3, 4, 5]
        },

        {
            label: "Weight Type",
            type: "options",
            key: "weight_type",
            visible: true,
            required: false,
            values: [{ key: 'weight_type_1', label: '1.4 oz & under' }, { key: 'weight_type_2', label: '1.5 oz - 2.1 oz' }, { key: 'weight_type_3', label: '2.2 oz - 2.9 oz' }, { key: 'weight_type_4', label: '3.0 oz & over' }],
            display_order: 2,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Total Count",
            type: "number",
            key: "total_count",
            visible: true,
            required: false,
            display_order: 3,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Weight",
            type: "number",
            key: "sample_weight",
            visible: true,
            required: false,
            display_order: 4,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "System Name",
            type: "number",
            key: "system_name",
            visible: true,
            required: false,
            display_order: 5,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Grower",
            type: "text",
            key: "seed_grower",
            visible: true,
            required: false,
            display_order: 6,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Variety",
            type: "text",
            key: "seed_variety",
            visible: true,
            required: false,
            display_order: 7,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Pulp Temp",
            type: "text",
            key: "seed_pulptemp",
            visible: true,
            required: false,
            display_order: 8,
            plan_type_ids: [1, 2, 3, 4, 5]
        },
        {
            label: "Sampler Name",
            type: "text",
            key: "sampler_name",
            visible: true,
            required: false,
            display_order: 9,
            plan_type_ids: [1, 2, 3, 4, 5]
        },

    ]
}

export const QR_TYPE = {
    EQUIPMENT_TRUCK: 3
};

export const geoCustom = {
    geo_custom_params: [
        {
            label: "Division",
            type: "text",
            key: "Division",
            placeholder: "Division",
            visible: true,
            required: false,
        },
        {
            label: "Area",
            type: "text",
            key: "Area",
            placeholder: "Area",
            visible: true,
            required: false,
        },
        {
            label: "Unit",
            type: "text",
            key: "Unit",
            placeholder: "Unit",
            visible: true,
            required: false,
        }
    ]
};

export const MAP_TYPE = ["roadmap", "terrain", "satellite", "hybrid"];
// export const numZeroToTen = Array.from({ length: 11 }, (_, i) => i);